"use client"
import {
  selectBookingStore,
  selectDailyAvgRent,
  selectDaysLength,
  selectHostFees,
  selectPdpFees,
  selectServiceFees,
} from "stores/booking/bookingSlice"
import { useAppSelector } from "stores/hooks"
import { formatDateRangeWithoutLeadingZero } from "utils/dates"

export const useBookingSummary = () => {
  const bookingStore = useAppSelector(selectBookingStore)
  const daysLength = useAppSelector(selectDaysLength)
  const dailyAvgRent = useAppSelector(selectDailyAvgRent)
  const hostFees = useAppSelector(selectHostFees)
  const serviceFee = useAppSelector(selectServiceFees)
  const pdpFees = useAppSelector(selectPdpFees)
  const discount = bookingStore.discount || 0

  const prequote = bookingStore.prequote
  const totalTax = prequote?.totalTax || 0
  const taxesAndFees =
    hostFees +
    serviceFee +
    totalTax +
    (bookingStore?.prequote?.taUpliftDiff || 0)
  const taCommission = prequote?.taCommission || 0
  const taUpliftFee = prequote?.taUpliftFee || 0
  const taUpliftDiff = taUpliftFee - taCommission

  const taUpliftMultiplier = prequote?.taUpliftMultiplier || 1
  const taUpliftCondition = prequote?.taUpliftCondition || 10

  const totalAmt =
    (bookingStore.totalAmt || 0) + (pdpFees || 0) - (discount || 0)
  const displayedNightlyRate = Math.max(dailyAvgRent - taUpliftFee, 0)
  const rent = displayedNightlyRate * daysLength

  const guestsCount =
    (bookingStore.adultNumber || 0) + (bookingStore.childNumber || 0)

  const formattedDateRange =
    bookingStore.startDate && bookingStore.endDate
      ? `${formatDateRangeWithoutLeadingZero(
          bookingStore.startDate,
          bookingStore.endDate,
        )}`
      : ""

  const guestLabel = `${guestsCount} ${guestsCount === 1 ? "Guest" : "Guests"}`
  const petSuffix = bookingStore.pet ? " & Pet" : ""

  const prequoteCommissionRate = prequote?.commissionRatePercent
  const derivedCommissionRate: number = prequoteCommissionRate
    ? prequoteCommissionRate
    : 0

  return {
    bookingStore,
    daysLength,
    dailyAvgRent,
    displayedNightlyRate,
    rent,
    taxesAndFees,
    taCommission,
    taUpliftFee,
    taUpliftDiff,
    taUpliftMultiplier,
    taUpliftCondition,
    totalAmt,
    guestsCount,
    guestLabel,
    petSuffix,
    formattedDateRange,
    derivedCommissionRate,
    discount,
  }
}
